/**
 * Sidepanel view
 *
 * Handling custom events on these references:
 * 'click #YourSidepanelReference .sidepanel-header .leftIcon'
 * 'click #YourSidepanelReference .sidepanel-header .rightIcon'
 */

define([
	'jquery',
	'underscore',
	'BaseView'
], function ($, _, BaseView) {

	'use strict';

	var Sidepanel = BaseView.extend({

		el: '.js_sidepanelView',

		/*
		 *	If your main content is different than this, set that value as a part of init.
		 */
		slideOutReference: $('.container-fluid.contents'),

		overlayHolder: $('body'),

		/*
		 *	Shows delay when the side panel is fading out.
		 *	This is useful in scenarios like, you just want the user to see the selection of funding instrument before it fades out.
		 */
		delay: false,

		/*
		*  This will decide, if header needs to be moved or not. False: will move it. True: will not move it.
		*/
		isOverpanel: false,

		/**
		 * Initialize the sidepanel
		 */
		initialize: function (options) {

			this.$body = $('body');

			this.options = options || {};

			if (this.options.slideOutReference) {
				this.slideOutReference = $(this.options.slideOutReference) || this.slideOutReference;

				/* If default is not passed, it's assumed that header is not required to be moved */
				this.isOverpanel = true;

				/*
				 * This is for temporary fix until new convention of global panel within the application is applied
				 */
				this.overlayHolder = this.slideOutReference;
			}
			if (!this.slideOutReference.length) {
				this.slideOutReference = $('.foreground-container');
			}
			this.delay = this.options.delay || this.delay;
			/* Set the new element to this view, if it is passed in the options */
			if (this.options.el) {
				this.setElement(this.options.el);
			}

			if (this.options.focusSelectorOnClose) {
				this.focusSelectorOnClose = this.options.focusSelectorOnClose;
			}

		},

		/**
		 * Set's the sidepanel's content (template, model, collection) and render it
		 * @param view - the view to render inside the sidepanel
		 * @returns {Sidepanel}
		 */
		setContent: function (view) {
			// the current view in the sidepanel
			this.view = view;

			this.template = view.template;
			if (view.model) {
				this.model = view.model;
			} else {
				this.collection = view.collection;
			}

			this.serialize = $.proxy(view.serialize, view);
			this.render();

			return this;
		},

		afterRender: function () {
			this.view.afterRender();
			this.showSidePanel();
		},

		/*
		 * Pass a unique ID to slide out, if it is different than the default one.
		 */
		showSidePanel: function () {
			var self = this;

			this.slideOutReference.addClass('open-side-panel');

			this.showWhiteOverlayMask();

			if (!this.isOverpanel) {
				$(document.body).addClass('vx_hasOpenSidepanel');
			}

			// `once` prevents flood of hideSidePanel() calls by `touchmove`
			$('.whiteOverlayMask').one('click touchmove', _.once(function () {
				self.hideSidePanel();
				$(this).off('click touchmove');
			}));

			this.shouldListenToEsc(true);
			this.onSidepanelOpen();

			this.$el.focus();
		},

		/*
		 *	@Private method
		 *	Utility method to add white overlay mask, when sidepanel is shown.
		 *	This is intended to be private method and do use this one.
		 *	Reason for adding Dom in JS, make this sidepanel widget more useful by providing support out of the box.
		 */
		showWhiteOverlayMask: function () {
			var $whiteOverlayMask = this.overlayHolder.find('.whiteOverlayMask'),
				self = this;

			if ($whiteOverlayMask.length === 0) {
				this.overlayHolder.append('<div class="whiteOverlayMask"></div>');
				setTimeout(function () {
					self.overlayHolder.find('.whiteOverlayMask').addClass('open-side-panel');
				}, 35);
			} else {
				$whiteOverlayMask.addClass('open-side-panel').removeClass('hide');
			}

			setTimeout(function () {
				self.overlayHolder.find('.whiteOverlayMask').addClass('isShown');
			}, 35);
		},

		/*
		 *	@Private method
		 *	Hides the whiteOverlayMask added by sidepanel.
		 */
		hideWhiteOverlayMask: function () {
			this.overlayHolder.find('.whiteOverlayMask').addClass('hide').removeClass('isShown').removeClass('open-side-panel');
		},

		/*
		 *	This is used to show a delay on user selection.
		 *	For ex: if funding option is selected, this can show selection to the user, before it goes away.
		 */
		hideSidePanelWithDelay: function () {
			var el = this.$el,
				$overlayHolder = this.overlayHolder,
				$slideOutReference = this.slideOutReference,
				isOverpanel = this.isOverpanel,
				focusSelectorOnClose = this.focusSelectorOnClose;

			setTimeout(function () {
				$slideOutReference.removeClass('open-side-panel');

				$overlayHolder.find('.whiteOverlayMask').addClass('hide').removeClass('isShown');

				if (!isOverpanel) {
					$(document.body).removeClass('vx_hasOpenSidepanel');
				}

				el.removeClass('open-side-panel');
				$(focusSelectorOnClose).focus();

			}, 500);

			this.shouldListenToEsc(false);
			this.onSidepanelClose();

		},

		/*
		 *	Hides the sidepanel and slides in the reference to this.slideOutReference
		 */
		hideSidePanel: function () {
			this.slideOutReference.removeClass('open-side-panel');

			this.hideWhiteOverlayMask();

			if (!this.isOverpanel) {
				$(document.body).removeClass('vx_hasOpenSidepanel');
			}

			this.$el.removeClass('open-side-panel');

			$(this.focusSelectorOnClose).focus();

			this.shouldListenToEsc(false);
			this.onSidepanelClose();
		},

		/**
		 * Returns if side panel is shown or not
		 */
		isShown: function() {
			return this.$el.hasClass('open-side-panel');
		},

		toggleSidePanel: function () {

			if (this.slideOutReference.hasClass('open-side-panel')) {

				if (this.delay) {
					this.hideSidePanelWithDelay();
				} else {
					this.hideSidePanel();
				}
			} else {
				this.showSidePanel();
			}
		},

		/*
		*	Custom function to take addition code that needs to be executed when the sidepanel opens.
		*/
		onSidepanelOpen: function () {
			// Abstract method, intended to be overridden.
		},

		/*
		*	Custom function to take addition code that needs to be executed when the sidepanel closes.
		*	One use case: Start listening to overpanel escape when the side panel is closed.
		*/
		onSidepanelClose: function () {
			// Abstract method, intended to be overridden.
		},

		/*
		*	Closes sidepanel on ESC event
		*/
		hideSidePanelOnESC: function (event) {
			if (event.which === 27) {
				this.hideSidePanelWithDelay();
			}
		},

		/**
		 * Listen for keydown and close overpanel if ESC was pressed
		 */
		shouldListenToEsc: function (listen) {
			if (listen) {
				this.$body.on('keydown', $.proxy(this.hideSidePanelOnESC, this));
			} else {
				this.$body.off('keydown', $.proxy(this.hideSidePanelOnESC, this));
			}
		}

	});

	return Sidepanel;

});



//////////////////
// WEBPACK FOOTER
// ./widgets/sidepanel.js
// module id = 823
// module chunks = 0